module.exports = __webpack_public_path__ + "img/jd1.42b84194.png";